var App = function() {
    var i = function() {},
        o = function() {
            $(document).ready(function() {
                $(".fixedPhoneBg").css("height", $(window).height()), $(window).scroll(function(i) {
                    var p = $(this).scrollTop();
                    var o = parseInt($("#fixedPage").offset().top) - 65,
                        e = parseInt($(".realTime").offset().top);
                    o < p && p < e ? ($(".fixedBox").css("position", "fixed"), $(".reportImg").css("marginTop", "17.9%"), $(".phoneFixed").css("height", $(window).height() - $(".phoneFixedTop").height() - $(".phoneFixedBottom").height() + 90)) : ($(".fixedBox").css("position", "absolute"), $(".reportImg").css("marginTop", "32.6%"))
                })
            })
        };
    return { init: function() { i(), o() } }
}();
App.init();